export default {
  name: 'about_name'
};